import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react'
import { StyleSheet, Text, View } from 'react-native'
import { Separator } from '../../../components/Separator'
import { InitialInputVoiceSearch } from '../../../components/VoiceSearch/InitialInput/InitialInput'
import { FreshWaterContext } from '../../../context/FreshWater/FreshWaterContext'
import { FormatPond } from '../../../context/FreshWater/types'
import { corporateColor } from '../../../theme/colors'
import { InfoState } from '..'
import { ListItem } from './ListItem'
import { useTranslation } from 'react-i18next'
import { Items } from '../../../navigator/types'

interface Props {
  roomId: number
  getValues: (value: InfoState) => void
  initValues?: Items[]
}

export const Ponds = ({ roomId, getValues, initValues }: Props) => {
  const { t } = useTranslation()
  const { ponds, states } = useContext(FreshWaterContext)
  const [pondsByRoom, setPondsByRooms] = useState<FormatPond[]>(() => ponds[roomId] ?? [])
  const [search, setSearch] = useState('')

  const getSearchValue = useCallback((value: string) => setSearch(value), [])

  const filteredData = useMemo(
    () => pondsByRoom.filter((pond) => pond.name.toLowerCase().includes(search.toLowerCase())),
    [search, pondsByRoom],
  )

  const options = useMemo(
    () =>
      states
        .map((option) => ({ id: option.id, name: t(option.name) }))
        .filter((item) => item.id !== 0),
    [states, t],
  )

  const defaultOptionsMap = useMemo(
    () =>
      initValues?.map((item) => ({
        id: item.stateId,
        name: t(item.stateName),
        levelThreeId: item.levelThreeId,
      })),
    [initValues, t],
  )

  useEffect(() => {
    setPondsByRooms(ponds[roomId] ?? [])
  }, [roomId, ponds])

  return (
    <View style={{ flexGrow: 10 }}>
      <InitialInputVoiceSearch
        placeholder='Búsqueda de estanques'
        getSearchValue={getSearchValue}
        hasInput
      />

      <View style={{ flexDirection: 'row', alignItems: 'center', padding: 10 }}>
        <View style={{ flex: 0.9 }}>
          <Text style={styles.headerText}>{t('ESTANQUE')}</Text>
        </View>
        <View style={{ flex: 1 }}>
          <Text style={styles.headerText}>{t('NUEVO ESTADO')}</Text>
        </View>
      </View>

      <Separator />
      {filteredData.map((item, index) => (
        <ListItem
          item={item}
          isLastItem={index + 1 === filteredData.length}
          key={item.id}
          options={options}
          onChange={getValues}
          defaultOptions={defaultOptionsMap?.find((value) => value.levelThreeId === item.id)}
        />
      ))}
    </View>
  )
}

const styles = StyleSheet.create({
  headerText: {
    color: corporateColor,
    fontWeight: 'bold',
  },
})
